<template>
  <div class="projectAdmin_Box">
    <el-card shadow="always">
      <div class="projectAdmin_Head">
        <el-form
          ref="formInline"
          label-width="100px"
          :model="formInline"
          inline
        >
          <el-form-item prop="projectName" label="表单项目名称">
            <el-input
              v-model="formInline.projectName"
              placeholder="请输入表单项目名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item class="head_Box">
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="handleReset" style="margin-left: 8px"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="projectAdmin_Title">
        <el-button type="primary" @click="handleProject({}, 'add')"
          >新建表单项目</el-button
        >
      </div>
      <div class="projectAdmin_Body">
        <el-table
          border
          stripe
          v-loading="loading"
          :data="data"
          style="width: 100%"
        >
          <el-table-column
            prop="projectCode"
            label="表单项目识别码"
            minWidth="260"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="projectName"
            label="表单项目"
            minWidth="230"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="voiceTitle"
            label="外呼语音title"
            minWidth="260"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="msgTemplate"
            label="短信模板"
            minWidth="240"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="enableIs"
            label="状态"
            minWidth="160"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag v-if="scope.row.enableIs === 1">已启用</el-tag>
              <el-tag v-else-if="scope.row.enableIs === 2" type="danger"
                >已停用</el-tag
              >
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column minWidth="150" align="center" label="操作">
            <template slot-scope="scope">
              <span class="blue_Box" @click="handleProject(scope.row, 'alter')"
                >编辑</span
              >
              <span
                class="blue_Box"
                v-if="scope.row.enableIs === 2"
                @click="handleEnable(scope.row, 1)"
                >启用</span
              >
              <span
                class="blue_Box"
                v-if="scope.row.enableIs === 1"
                @click="handleEnable(scope.row, 2)"
                >停用</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <my-pagination
        :page-info="pageInfo"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
      <div class="projectAdmin_Page">
        <!-- <el-pagination
          @current-change="pageChange"
          :current-page.sync="pageInfo.page"
          :page-size="pageInfo.limit"
          layout="prev, pager, next, jumper"
          :total="pageInfo.total"
        >
        </el-pagination> -->
        <!-- <Page
          :total="pageInfo.total"
          :page-size="pageInfo.limit"
          show-elevator
          @on-change="pageChange"
          :current="pageInfo.page"
        /> -->
      </div>
    </el-card>

    <!-- 新增、编辑 -->
    <el-dialog
      :visible.sync="modalBool"
      width="700px"
      :title="modalTitle"
      :before-close="cancel"
    >
      <el-form
        ref="formValidate"
        :model="formValidate"
        :rules="ruleValidate"
        label-width="140px"
      >
        <el-form-item label="表单项目" prop="projectName">
          <el-input
            v-model="formValidate.projectName"
            placeholder="请输入表单项目"
            maxlength="20"
            @input="projectNameValue"
          ></el-input>
        </el-form-item>
        <el-form-item label="表单项目识别码" prop="projectCode">
          <el-input
            v-model="formValidate.projectCode"
            placeholder="请输入表单项目识别码"
            maxlength="10"
            @input="projectCodeValue"
          ></el-input>
        </el-form-item>
        <!-- 限制规则 -->
        <!-- @input="voiceTitleValue" -->
        <el-form-item label="外呼语音title" prop="voiceTitle">
          <el-input
            v-model="formValidate.voiceTitle"
            placeholder="请输入外呼语音title"
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item label="短信模板" prop="msgTemplate">
          <el-row>
            <el-col span="22">
              <el-input
                v-model="formValidate.msgTemplate"
                type="textarea"
                maxlength="200"
                show-word-limit
                :autosize="{ minRows: 4, maxRows: 5 }"
                placeholder="请输入短信模板"
              ></el-input>
            </el-col>
            <el-col span="2">
              <el-popover placement="top" width="290">
                <div style="margin-bottom: 4px;">1.短信模板之间关系由短信签名对应，需正确填写。</div>
                <div>2.销售人员信息变量："+saleWechat+"。</div>
                <div slot="reference" style="padding-left: 6px;">
                  <i class="el-icon-question" style="font-size: 22px;cursor: pointer;"></i>
                </div>
              </el-popover>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="affirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  analyseProject,
  addAnalyseProject,
  updateAnalyseProject,
  checkAnalyseProject,
} from "@/api/projectAdmin.js";
import { clone, processing } from "@/utils/handle.js";
import myPagination from "@/components/myPagination.vue";
export default {
  components: {
    myPagination,
  },
  data() {
    const validateProjectName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("内容不能为空"));
      } else {
        if (this.modalTitle === "新增表单项目") {
          checkAnalyseProject({ projectName: value }).then((res) => {
            if (!res.data) {
              callback(new Error("内容重复，请修改后再试"));
            } else {
              callback();
            }
          });
        } else {
          if (this.oldProjectName === value) {
            callback();
          } else {
            checkAnalyseProject({ projectName: value }).then((res) => {
              if (!res.data) {
                callback(new Error("内容重复，请修改后再试"));
              } else {
                callback();
              }
            });
          }
        }
      }
    };
    const validateProjectCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("内容不能为空"));
      } else {
        if (this.modalTitle === "新增表单项目") {
          checkAnalyseProject({ projectCode: value }).then((res) => {
            if (!res.data) {
              callback(new Error("内容重复，请修改后再试"));
            } else {
              callback();
            }
          });
        } else {
          if (this.oldProjectCode === value) {
            callback();
          } else {
            checkAnalyseProject({ projectCode: value }).then((res) => {
              if (!res.data) {
                callback(new Error("内容重复，请修改后再试"));
              } else {
                callback();
              }
            });
          }
        }
      }
    };
    return {
      formInline: {
        projectName: "",
      },
      formValidate: {
        projectName: "",
        projectCode: "",
        voiceTitle: "",
        msgTemplate: "",
      },
      ruleValidate: {
        projectName: [
          { required: true, validator: validateProjectName, trigger: "blur" },
        ],
        projectCode: [
          { required: true, validator: validateProjectCode, trigger: "blur" },
        ],
        voiceTitle: [
          {
            required: true,
            message: "内容不能为空",
            trigger: "blur",
          },
        ],
        msgTemplate: [
          {
            required: true,
            message: "内容不能为空",
            trigger: "blur",
          },
        ],
      },
      modalBool: false,
      modalTitle: "",
      loading: false,
      data: [],
      id: "",
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
      searchData: {},
      oldProjectName: "",
      oldProjectCode: "",
    };
  },
  mounted() {
    this.analyseProject({ page: 1, limit: 10 });
  },
  activated() {
    this.analyseProject({ page: 1, limit: 10 });
  },
  methods: {
    // 修改状态
    handleEnable(payload, status) {
      let str = status === 1 ? "启用" : "停用";
      this.$confirm(`确认要${str}吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        updateAnalyseProject({ id: payload.id, enableIs: status }).then(
          (res) => {
            if (res.code === 0) {
              this.$message({
                type: "success",
                message: `${str}成功!`,
              });
              this.refresh();
            }
          }
        );
      });
    },
    // 刷新
    refresh() {
      this.analyseProject(
        Object.assign(this.searchData, {
          page: this.pageInfo.page,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 表单项目校验
    projectNameValue(payload) {
      this.$nextTick(() => {
        this.$set(
          this.formValidate,
          "projectName",
          payload.replace(/[^A-Za-z0-9\u4e00-\u9fa5]/g, "")
        );
      });
    },
    // 表单项目识别码校验
    projectCodeValue(payload) {
      this.$nextTick(() => {
        this.$set(
          this.formValidate,
          "projectCode",
          payload.replace(/[^0-9]/g, "")
        );
      });
    },
    // 外呼语音title
    // voiceTitleValue(payload) {
    //   this.$nextTick(() => {
    //     this.$set(
    //       this.formValidate,
    //       "voiceTitle",
    //       payload.replace(/[^A-Za-z0-9\u4e00-\u9fa5]/g, "")
    //     );
    //   });
    // },
    // 列表请求
    async analyseProject(payload) {
      this.loading = true;
      this.pageInfo.page = payload.page;
      this.pageInfo.limit = payload.limit;
      const datas = clone(payload);
      const res = await analyseProject(Object.assign({}, datas));
      this.data =
        res.data && res.data.records && res.data.records.length > 0
          ? res.data.records
          : [];
      this.pageInfo.total = Number(res.data.total);
      this.loading = false;
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.analyseProject(
        Object.assign(clone(this.searchData), {
          page: payload,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.analyseProject(
        Object.assign(clone(this.searchData), { page: 1, limit: payload })
      );
    },
    // 新增表单项目
    handleProject(payload, status) {
      this.modalTitle = status === "alter" ? "编辑表单项目" : "新增表单项目";
      this.modalBool = true;
      if (status === "add") {
        this.$nextTick(() => {
          this.$refs["formValidate"].resetFields();
        });
        this.oldProjectName = "";
        this.oldProjectCode = "";
      } else if (status === "alter") {
        this.formValidate = {
          projectName: payload.projectName,
          projectCode: payload.projectCode,
          voiceTitle: payload.voiceTitle,
          msgTemplate: payload.msgTemplate,
        };
        this.oldProjectName = payload.projectName;
        this.oldProjectCode = payload.projectCode;
        this.id = payload.id;
      }
    },
    // 重置
    handleReset() {
      this.searchData = {};
      this.$refs["formInline"].resetFields();
      this.analyseProject({
        page: 1,
        limit: 10,
      });
    },
    // 搜索
    handleSearch() {
      this.searchData = processing(this.formInline);
      this.analyseProject(
        Object.assign(processing(this.formInline), {
          page: 1,
          limit: 10,
        })
      );
    },
    // 确认
    affirm() {
      this.$refs["formValidate"].validate((valid) => {
        if (valid) {
          if (this.modalTitle === "新增表单项目") {
            addAnalyseProject(this.formValidate).then((res) => {
              if (res.code === 0) {
                this.$message({
                  type: "success",
                  message: "添加成功!",
                });
                this.refresh();
              }
            });
          } else if (this.modalTitle === "编辑表单项目") {
            updateAnalyseProject(
              Object.assign({ id: this.id }, clone(this.formValidate))
            ).then((res) => {
              if (res.code === 0) {
                this.$message({
                  type: "success",
                  message: "编辑成功!",
                });
                this.refresh();
              }
            });
          }
          this.modalBool = false;
        }
      });
    },
    // 取消
    cancel() {
      this.modalBool = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.projectAdmin_Head {
  margin-top: 10px;
}
.projectAdmin_Title {
  margin-bottom: 10px;
}
.projectAdmin_Body {
  .blue_Box {
    margin: 0 6px;
    color: #2d8cf0;
    cursor: pointer;
  }
  .blue_Box:hover {
    color: #57a3f4;
  }
}
.projectAdmin_Page {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
